<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>校园视力筛查系统</el-breadcrumb-item>
      <el-breadcrumb-item>学生管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入学生姓名" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.phone" @keyup.enter.native="clicksearch" placeholder="请输入家长手机号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.school" @keyup.enter.native="clicksearch" placeholder="请输入学校名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.grade" @keyup.enter.native="clicksearch" placeholder="请输入年级班级" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.idnumber" @keyup.enter.native="clicksearch" placeholder="请输入身份证号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="primary" @click="clickexcel">批量下载视力数据</el-button>
            <el-button type="primary" @click="clickqrcode">批量下载二维码</el-button>
            <el-button type="success" @click="clickmuban">下载导入模板</el-button>
            <TencentyunCosUploadExcel @change="changeTencentyunCosUploadExcel"></TencentyunCosUploadExcel>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Jigouname" label="门店名称" min-width="10%"></el-table-column>
          <el-table-column prop="Name" label="学生姓名" min-width="10%"></el-table-column>
          <el-table-column prop="Phone" label="家长手机号" min-width="5%"></el-table-column>
          <el-table-column prop="School" label="学校名称" min-width="5%"></el-table-column>
          <el-table-column prop="Grade" label="年级班级" min-width="8%"></el-table-column>
          <el-table-column prop="Idnumber" label="身份证号" min-width="10%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="10%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="6%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickmodify(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdel(scope.row)">删除</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdushu(scope.row)">查看视力</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加学生信息" name="second">
      <el-form :model="addForm" ref="addFormRef" label-width="170px">
        <el-form-item label="学生姓名" class="addAdminForm">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">家长手机号(必填)</span>
          </label>
          <el-input v-model="addForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="学校名称" class="addAdminForm">
          <el-input v-model="addForm.school"></el-input>
        </el-form-item>
        <el-form-item label="年级班级" class="addAdminForm">
          <el-input v-model="addForm.grade"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" class="addAdminForm">
          <el-input v-model="addForm.idnumber"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

    <!-- 修改 start -->
    <el-tab-pane label="修改学生信息" name="three" disabled="disabled">
      <el-form :model="editForm" ref="editFormRef" label-width="170px">
        <el-form-item label="学生姓名" class="addAdminForm">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">家长手机号(必填)</span>
          </label>
          <el-input v-model="editForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="学校名称" class="addAdminForm">
          <el-input v-model="editForm.school"></el-input>
        </el-form-item>
        <el-form-item label="年级班级" class="addAdminForm">
          <el-input v-model="editForm.grade"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" class="addAdminForm">
          <el-input v-model="editForm.idnumber"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 修改 end -->

    <el-tab-pane label="视力" name="four" disabled="disabled">
      <RuischoolscUserDuShu ref="SubVuefour" v-on:triggerFunc="BackToFirst"></RuischoolscUserDuShu>
    </el-tab-pane>

  </el-tabs>
  </div>
</template>

<script>
import RuischoolscUserDuShu from '@/componentsSubVue/RuischoolscUserDuShu.vue'
import TencentyunCosUploadExcel from '@/components/TencentyunCosUploadExcel.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    RuischoolscUserDuShu,
    TencentyunCosUploadExcel
  },
  name: 'MyRuischoolscUser',
  data () {
    return {
      activeName: 'first',
      addForm: {
        name: '',
        phone: '',
        school: '',
        grade: '',
        idnumber: ''
      },
      editForm: {
        id: '0',
        name: '',
        phone: '',
        school: '',
        grade: '',
        idnumber: ''
      },
      // 查询
      keywords: {
        name: '',
        phone: '',
        school: '',
        grade: '',
        idnumber: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1
    }
  },
  mounted () {
    this.apiGetRuischoolscUserNum()
    this.apiGetRuischoolscUserList()

    this.addForm.visitorstimein = Vue.prototype.FunGetTimeStringLong()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    clickadd () {
      this.apiAddRuischoolscUser()
    },
    clickmuban () {
      window.open('https://erp-1256233047.cos.ap-shanghai.myqcloud.com/muban/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF%E6%A0%A1%E5%9B%AD%E8%A7%86%E5%8A%9B%E7%AD%9B%E6%9F%A5%E7%B3%BB%E7%BB%9F.xlsx')
    },
    changeTencentyunCosUploadExcel (url) {
      this.apiExcelImportRuischoolscUser(url)
    },
    clickqrcode(){
      this.apiZipFileRuischoolscUser()
    },
    clickexcel () {
      this.apiExcelRuischoolscUser()
    },
    clickmodify (row) {
      this.activeName = 'three'

      this.editForm.id = row.Id
      this.editForm.name = row.Name
      this.editForm.phone = row.Phone
      this.editForm.school = row.School
      this.editForm.grade = row.Grade
      this.editForm.idnumber = row.Idnumber
    },
    // 查看视力
    clickdushu (row) {
      this.activeName = 'four'
      this.$refs.SubVuefour.LoadData({ name: '', params: { useruuid: row.Useruuid, } })
    },
    clicksave () {
      this.apiEditRuischoolscUser()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickdel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelRuischoolscUser(row.Id)
      })
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetRuischoolscUserNum()
      this.apiGetRuischoolscUserList()
    },
	delaysearch () {
	  var that = this
	  setTimeout(function () {
	    that.clicksearch()
	  }, 2000)
	},
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetRuischoolscUserList()
    },
    apiGetRuischoolscUserNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.keywords.name,
        phone: that.keywords.phone,
        school: that.keywords.school,
        grade: that.keywords.grade,
        idnumber: that.keywords.idnumber
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetRuischoolscUserNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetRuischoolscUserList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        name: that.keywords.name,
        phone: that.keywords.phone,
        school: that.keywords.school,
        grade: that.keywords.grade,
        idnumber: that.keywords.idnumber
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetRuischoolscUserList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddRuischoolscUser: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.addForm.name,
        phone: that.addForm.phone,
        school: that.addForm.school,
        grade: that.addForm.grade,
        idnumber: that.addForm.idnumber
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddRuischoolscUser, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetRuischoolscUserNum()
            that.apiGetRuischoolscUserList()

            // 清空添加
            that.addForm.name = ""
            that.addForm.phone = ''
            that.addForm.school = ''
            that.addForm.grade = ''
            that.addForm.idnumber = ''
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelRuischoolscUser: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelRuischoolscUser, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetRuischoolscUserNum()
            that.apiGetRuischoolscUserList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditRuischoolscUser: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editForm.id,
        name: that.editForm.name,
        phone: that.editForm.phone,
        school: that.editForm.school,
        grade: that.editForm.grade,
        idnumber: that.editForm.idnumber
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditRuischoolscUser, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetRuischoolscUserNum()
            that.apiGetRuischoolscUserList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelImportRuischoolscUser: function (url) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        fileurl: url
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelImportRuischoolscUser, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
          that.delaysearch()
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiZipFileRuischoolscUser: function (url) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.keywords.name,
        phone: that.keywords.phone,
        school: that.keywords.school,
        grade: that.keywords.grade,
        idnumber: that.keywords.idnumber
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ZipFileRuischoolscUser, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
          that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            showCancelButton: true,
            type: 'warning'
          }).then(() => {
            that.$router.push({ path: '/FileManagementExcel' })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelRuischoolscUser: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.keywords.name,
        phone: that.keywords.phone,
        school: that.keywords.school,
        grade: that.keywords.grade,
        idnumber: that.keywords.idnumber
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelRuischoolscUser, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
